// Libs
import React, { useState, useContext, useEffect, useRef } from "react";
import { useObserver, KeyValuePair, FieldType, Else, EditableInput, TypographyX } from "@shoothill/core";
import SignaturePad from "react-signature-pad-wrapper";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { FormLabel, Box, Typography, Checkbox, FormControlLabel, Radio, FormControl, Button, Select, InputAdornment, TextField } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";

// App
import { StoresContext, Stores } from "Globals/Stores";

// Models
import { HomeOwnerStatusEnum } from "Globals/Models/HomeOwnerStatusEnum";

// ViewModels
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";
import ApplicantViewModel from "Globals/ViewModels/ApplicantViewModel";

// Views
import { FileUploader } from "Globals/Views/FileUploader";

// Styles
import { theme } from "Globals/Styles/AppTheme";
import { Row } from "Globals/Styles/LayoutStyles";
import { UserFile } from "Globals/Models/UserFile";
import CreditReportViewModel from "Globals/ViewModels/FormSections/CreditReport/CreditReportViewModel";

interface IProps {
    applicant: ApplicantViewModel;
    applicationFormViewModel: ApplicationFormViewModel;
}

export const CreditReportView: React.FC<IProps> = (props: IProps) => {
    const storesContext = useContext<Stores>(StoresContext);
    const [viewModel] = useState(props.applicant.parentCreditReportViewModel);
    const [creditViewModel] = useState(new CreditReportViewModel());

    React.useEffect(() => {
        props.applicationFormViewModel.applicantViewModels.find((vm) => vm.parentCreditReportViewModel.setValue("reportsRequired", true));
    }, []);

    return useObserver(() => (
        <div
            onKeyUp={() => {
                viewModel.restartTimer();
            }}
        >
            {viewModel.DevTool_ShowCanProceed && <h5 style={{ color: "red" }}>Can Proceed: {viewModel.canProceed ? "Yes" : "No"}</h5>}
            {viewModel.getError("creditReportModels") !== "" && (
                <p style={{ color: theme.palette.error.main, position: "absolute", fontSize: "14px" }}>{viewModel.getError("creditReportModels")}</p>
            )}
            <Row>
                <Typography variant="body2">Full Credit Report required. A copy of Credit Score will not be accepted.</Typography>
            </Row>
            <Row>
                <FileUploader
                    files={viewModel.getUserFiles}
                    text={"Upload your credit report"}
                    onUpload={(userFile: UserFile) => {
                        creditViewModel.save(userFile, viewModel);
                        viewModel.handleInputChange();
                    }}
                    onDelete={(userFile: UserFile) => {
                        let vm = viewModel.creditReportViewModels.find((vm) => vm.model.creditDocumentUrl == userFile.fileUrl);
                        if (vm) {
                            vm.save(userFile, viewModel, true);
                        }
                        viewModel.handleInputChange();
                    }}
                    disabled={props.applicationFormViewModel.model.isSubmitted}
                />
            </Row>
        </div>
    ));
};
